import { OrganizerRoutes } from './organizer-routes'
import { SharedRoutes } from './shared-routes'
import { TicketSellerRoutes } from './ticket-seller-routes'
import { AdminRoutes } from './admin-routes'
import { TheaterOrganizerRoutes } from './theater-organizer-routes'
import { TicketSellerAdminRoutes } from './ticket-seller-admin-routes'
import { SportOrganizerRoutes } from '@/routing/routes/sport-organizer-routes'

/**
 * Routes used by Router
 *
 * MainRoutes include all routes for all user types, except ungroupedRoutes,
 * because they don't have the same design layout.
 *
 * They are implemented in MainNavigator
 */

export const MainRoutes = [
  ...TicketSellerRoutes,
  ...TicketSellerAdminRoutes,
  ...TheaterOrganizerRoutes,
  ...SportOrganizerRoutes,
  ...OrganizerRoutes,
  ...AdminRoutes,
  ...SharedRoutes,
]
